export default "__VITE_ASSET__BlcblQhc__"